import React from 'react';
import PostSendModal from '../PostSendModal/PostSendModal';
import { Subtitle, Icon } from '@landing/ui';
import { defaultModalsId } from '../constants';
import { email } from 'define';

import * as styles from './ErrorModal.module.scss';

export default function ErrorModal() {
  const icon = () => <Icon name="warning" className={styles.icon} />;

  return (
    <PostSendModal Icon={icon} modalID={defaultModalsId.errorModal}>
      <div className={styles.wrapper}>
        <Subtitle className={styles.text}>Ihre Anfrage wurde leider nicht gesendet.</Subtitle>
        <Subtitle className={styles.contact}>
          {'Bitte versuchen Sie es erneut oder kontaktieren Sie uns per E-Mail '}
          <a href={`mailto:${email}`} className={styles.link}>
            {email}
          </a>
        </Subtitle>
      </div>
    </PostSendModal>
  );
}
